import api from "../../services/api";
import { mapGetters } from "vuex";
import router from "../../router";
import localStorage from "../../services/storage";
import RightContainerHeader from "./Partials/RightContainerHeader.vue";
import RightContainerTotals from "./Partials/RightContainerTotals.vue";
import { EventBus } from '../../EventBus';

export default {
  props: {
    showContinue: {
      type: Boolean,
      default: true,
    },
    buyButtonForTopAction: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      canContinueButton: false,
      mobileTariff: {},
      device: {},
      tVTariff: {},
      tVdevice: {},
      box: {},
      sIM: {},
      other: {},
      bundle: [],
      limit: 0,
      insurance: false,
      postBill: false,
      rightSide: {
        oneTime: 0,
        billing: 0,
        total: 0,
      },
      spec: {},
      prefix: localStorage.get("locale", true) === "de" ? "/de" : "/sr",
      checkoutId: localStorage.get("checkout-id", true),
      smartTariffNames: ["SMART 30", "SMART 60", "SMART 100"],
      isContentExpanded: false,
    };
  },

  components: {
    RightContainerHeader,
    RightContainerTotals,
  },

  computed: {
    ...mapGetters(["checkout", "chosenTv", "bonusTv", "isGeneralCheckout", "termsAccepted"]),

    actionTotals() {
      let discount = this.toPrice(this.spec.action_old_price) - this.toPrice(this.spec.action_price);
      let totalWithDiscount = this.rightSide.total;
      let totalWithoutDiscount = this.toPrice(this.rightSide.total) + discount;

      return {
        price: this.spec.action_price,
        oldPrice: this.spec.action_old_price,
        discount: discount.toFixed(2).replace('.', ','),
        totalWithDiscount: totalWithDiscount,
        totalWithoutDiscount: totalWithoutDiscount.toFixed(2).replace('.', ',')
      }
    },

    animatedStyle() {
      if (window.innerWidth < 1200) {
        return { "max-height": this.isContentExpanded ? "50vh" : "0px" };
      }
      return {}; // Return an empty object when the resolution is above 1024px
    },

    // Gets the header params for the RightContainerHeader component
    getHeaderParams() {
      // Mobile Tariff
      if (Object.keys(this.mobileTariff).length > 0) {
        let bindingNotice = null;
        if (!this.binding) {
          bindingNotice = {
            total: this.$options.filters.priceFilter(this.mobileTariff.total),
            notice: this.checkout.old_price
              ? `* ${this.$i18nApi.t(
                  "checkout1Right.simOnlyNotice"
                )} ${this.$options.filters.priceFilter(
                  this.checkout.old_price
                )}`
              : null,
          };
        }
        return {
          title: this.$i18nApi.t("checkout1Right.tariff"),
          subtitle: this.mobileTariff.name,
          bindingNotice: bindingNotice || null,
        };
      }

      // SIM
      if (Object.keys(this.sIM).length > 0) {
        return {
          title: this.$i18nApi.t("checkout2.sim"),
          subtitle: this.sIM.name.toUpperCase(),
        };
      }

      // TV Tariff
      if (Object.keys(this.tVTariff).length > 0) {
        return {
          title: this.$i18nApi.t("checkout1Right.tariff"),
          subtitle: this.tVTariff.name,
        };
      }

      return {};
    },

    // Gets the totals params for the RightContainerTotals component
    getTotalsParams() {
      // Mobile Tariff
      if (
        Object.keys(this.mobileTariff).length > 0 &&
        !Object.keys(this.device).length > 0
      ) {
        return {
          label:
            parseInt(this.rightSide.billing) > 0
              ? this.$i18nApi.t("checkout2Right.totalSimOnly")
              : this.$i18nApi.t("checkout2Right.total"),
          price: this.$options.filters.priceFilter(this.rightSide.billing),
        };
      }

      // TV Tariff
      if (
        !Object.keys(this.device).length > 0 &&
        !Object.keys(this.mobileTariff).length > 0
      ) {
        const showOneTime =
          parseInt(this.rightSide.billing) > 0 &&
          !Object.keys(this.tVTariff).length;
        return {
          oneTimeLabel: showOneTime
            ? this.$i18nApi.t("checkout2Right.oneTimeTotal")
            : null,
          oneTimePrice: showOneTime
            ? this.$options.filters.priceFilterWithoutMo(this.rightSide.billing)
            : null,
          label:
            parseInt(this.rightSide.billing) > 0
              ? this.$i18nApi.t("checkout2Right.totalSimOnly")
              : this.$i18nApi.t("checkout2Right.total"),
          price: this.$options.filters.priceFilterWithoutMo(
            this.rightSide.total
          ),
        };
      }

      // Device
      if (Object.keys(this.device).length > 0) {
        return {
          label: this.$i18nApi.t("checkout2Right.total"),
          price: this.$options.filters.priceFilter(this.rightSide.billing),
        };
      }

      return {};
    },

    isSmartTariff() {
      return this.smartTariffNames.includes(this.mobileTariff.name);
    },

    bindingFirst() {
      if (this.smartTariffNames.includes(this.mobileTariff.name)) {
        return "24 " + this.$i18nApi.t("months");
      }

      return this.binding;
    },

    binding() {
      if (
        this.mobileTariff.binding == 182400001 ||
        this.tVTariff.binding == 182400001
      ) {
        if (this.tVTariff.binding == 182400001) {
          return "21 " + this.$i18nApi.t("oneMonth");
        }

        if (this.mobileTariff.name == "SMARTWATCH") {
          return "24 " + this.$i18nApi.t("months");
        }

        return "24 " + this.$i18nApi.t("months");
      }

      if (
        this.mobileTariff.binding == 182400002 ||
        this.tVTariff.binding == 182400002
      ) {
        return "1 " + this.$i18nApi.t("oneMonth");
      }
      // if (this.tVTariff.tvDuration) {
      //     return this.tVTariff.tvDuration;
      // }
      return "";
    },

    bindingFor() {
      if (
        this.mobileTariff.binding == 182400001 ||
        this.tVTariff.binding == 182400001
      ) {
        return (
          this.$i18nApi.t("for") +
          " " +
          this.$i18nApi.tc("pluralizedMonts", this.getPluralizeMonthIndex(24), {
            n: 24,
          })
        );
      }
      if (
        this.mobileTariff.binding == 182400002 ||
        this.tVTariff.binding == 182400002
      ) {
        return this.$i18nApi.t("for") + " 1 " + this.$i18nApi.t("oneMonth");
      }
      if (this.tVTariff.tvDuration) {
        return (
          this.tVTariff.tvDuration +
          " " +
          this.$i18nApi.tc(
            "pluralizedMonts",
            this.getPluralizeMonthIndex(this.tVTariff.tvDuration),
            { n: this.tVTariff.tvDuration }
          )
        );
      }
      return "";
    },
  },

  methods: {
    toggleContent() {
      this.isContentExpanded = !this.isContentExpanded;
    },

    emitPurchaseEvent() {
      EventBus.$emit('purchaseEvent', true);
    },
    
    reset() {
      this.mobileTariff = {};
      this.device = {};
      this.tVTariff = {};
      this.tVdevice = [];
      this.box = {};
      this.sim = {};
      this.other = {};
      this.bundle = [];
      this.limit = 0;
      this.insurance = 0;
      this.postBill = false;
      this.spec = {};
    },

    getPluralizeMonthIndex(duration) {
      const num = duration.toString().substr(duration.toString().length - 1);

      if (num == 1 && !(num == 11)) {
        return 0;
      }
      if (
        (num == 2 || num == 3 || num == 4) &&
        !(duration == 12 || duration == 13 || duration == 14)
      ) {
        return 1;
      }
      if (
        duration == 11 ||
        duration == 12 ||
        duration == 13 ||
        duration == 14
      ) {
        return 2;
      }

      return 2;
    },

    getData(enableButton = false) {
      this.canContinueButton = false;
      api.post("/public-api/checkout", this.checkout).then((response) => {
        this.reset();
        this.processResponseData(response.data);

        this.$root.$emit("checkoutReady");

        const isGeneralCheckout = !(
          Object.keys(this.sIM).length > 0 ||
          (Object.keys(this.tVTariff).length > 0 && !this.tVTariff.postpaid)
        );
        this.$store.commit("SET_USE_PREPAID_STEPS", Object.keys(this.sIM).length > 0);
        this.$store.commit("SET_IS_GENERAL_CHECKOUT", isGeneralCheckout);

        if (enableButton) {
          this.canContinueButton = true;
        }
      });
    },

    processResponseData(data) {
      data.items.forEach(item => {
          const key = Object.keys(item)[0];
          const value = Object.values(item)[0];

          if (key === 'tVdevice' || key === 'bundle') {
              if (!this[key]) this[key] = [];
              this[key].push(value);
          } else {
              if (data.spec['action'] && key !== 'device') data.spec['action_price'] = value.total;
              this[key] = value;
          }
      });

      //this.limit = data.limit;
      this.action = data.action;
      this.spec = data.spec;
      this.rightSide.oneTime = data.oneTime;
      this.rightSide.billing = data.billing;
      this.rightSide.total = data.total;
    },

    toPrice(value) {
      return parseFloat(value.replace(',', '.'));
    },

    /**
     * Check if user picked the tariff but has forgotten to pick the channel
     * @return {*}
     */
    checkCanContiueTv() {
      if (this.bonusTv && Object.keys(this.chosenTv).length === 0) {
        return this.$swal(this.$i18nApi.t("messages.errorNotPickedChosenTv"));
      }

      router.push({ name: "checkout-step-2" });
    },

    buyTopAction() {
      window.location.href = "/checkout/1";
    },
  },

  mounted() {
    this.getData();

    this.$root.$on("reloadCheckout", (enableButton) =>
      this.getData(enableButton)
    );
    this.$root.$on(
      "enableContinueButton",
      () => (this.canContinueButton = true)
    );
  },
};
